module.exports = __webpack_public_path__ + "img/img-abf5f740.04638009.png";